export const getSize = (page, currentPage, totalPages, numOnDisplay) => {
  const distFromCurrentPage = Math.abs(page - currentPage)
  const distCurrentFromEnd = Math.abs(totalPages - currentPage)
  const distCurrentFromStart = currentPage
  const maxPagesEitherSide = Math.floor(numOnDisplay / 2)

  // set current page to be large
  if (page === currentPage) {
    return 1
    // if fewer items than max pages displayed, hardcode all non-current to be normal size
  } else if (totalPages <= numOnDisplay) {
    return 1
    // check if in start block
  } else if (distCurrentFromStart <= maxPagesEitherSide) {
    if (page <= numOnDisplay - 2) {
      return 1
    } else if (page === numOnDisplay - 1) {
      return 0.6
    }
    // check if in end block
  } else if (distCurrentFromEnd <= maxPagesEitherSide + 1) {
    if (page >= totalPages - (numOnDisplay - 1)) {
      return 1
    } else if (page === totalPages - numOnDisplay) {
      return 0.6
    }
    // middle behaviour
  } else if (distFromCurrentPage <= maxPagesEitherSide - 1) {
    return 1
  } else if (distFromCurrentPage <= maxPagesEitherSide) {
    return 0.6
  }
  return 0
}

export const getContainerPosition = (currentPage, totalPages, numOnDisplay) => {
  const maxPagesEitherSide = Math.floor(numOnDisplay / 2)
  let index
  if (totalPages <= numOnDisplay) {
    index = 0
    // freeze container position once it hits start/end of pages
  } else if (currentPage <= maxPagesEitherSide + 1) {
    index = 0
  } else if (currentPage >= totalPages - maxPagesEitherSide) {
    index = totalPages - numOnDisplay
  } else {
    index = currentPage - (maxPagesEitherSide + 1)
  }
  return index * -18
}
